import React from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useNavigationStore } from '../../stores/navigationStore';
import { getBreadcrumbs } from './breadcrumbConfig';
import '../../styles/Breadcrumb.css';

const ChevronSep: React.FC = () => (
  <svg className="breadcrumb-bar__sep" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M9 5l7 7-7 7" />
  </svg>
);

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const projectId = useNavigationStore((s) => s.projectId);
  const projectName = useNavigationStore((s) => s.projectName);
  const fileId = useNavigationStore((s) => s.fileId);
  const fileName = useNavigationStore((s) => s.fileName);
  const moleculeId = useNavigationStore((s) => s.moleculeId);
  const moleculeName = useNavigationStore((s) => s.moleculeName);
  const previousPath = useNavigationStore((s) => s.previousPath);
  const previousLabel = useNavigationStore((s) => s.previousLabel);
  const clearPreviousNavigation = useNavigationStore((s) => s.clearPreviousNavigation);

  const crumbs = getBreadcrumbs(
    location.pathname,
    { projectId, projectName, fileId, fileName, moleculeId, moleculeName },
    searchParams,
  );

  // Nothing to show if there's only one crumb and no back link
  if (crumbs.length <= 1 && !previousPath) return null;

  const handleBackClick = () => {
    if (previousPath) {
      navigate(previousPath);
      clearPreviousNavigation();
    }
  };

  return (
    <div className="breadcrumb-bar" role="navigation" aria-label="Breadcrumb">
      <nav className="breadcrumb-bar__trail" aria-label="Breadcrumb trail">
        {crumbs.map((crumb, idx) => {
          const isLast = idx === crumbs.length - 1;
          return (
            <React.Fragment key={idx}>
              {idx > 0 && <ChevronSep />}
              {!isLast && crumb.path ? (
                <Link to={crumb.path} className="breadcrumb-bar__link">
                  {crumb.label}
                </Link>
              ) : (
                <span className="breadcrumb-bar__current" aria-current={isLast ? 'page' : undefined}>
                  {crumb.label}
                </span>
              )}
            </React.Fragment>
          );
        })}
      </nav>

      {previousPath && previousLabel && (
        <button className="breadcrumb-bar__back" onClick={handleBackClick}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to {previousLabel}
        </button>
      )}
    </div>
  );
};

export default Breadcrumb;
